import Layout from '@ep/components/Layout';
import SEO from '@ep/components/Seo';
import PostCarouselModule from '@ep/modules/PostCarouselModule';
import PostMarkupModule from '@ep/modules/PostMarkupModule';
import PostModule from '@ep/modules/PostModule';
import { Gcms_Post } from '@ep/types/gatsbyTypes';
import getIntersection from '@ep/utils/getIntersection';
import { WindowLocation } from '@reach/router';
import { graphql } from 'gatsby';
import React from 'react';

export interface PostDetailsProps {
  location: WindowLocation;
  data: {
    gcms: {
      post: Gcms_Post;
      relatedPosts: Gcms_Post[];
    };
  };
}

const filterRelatedPosts = (arr: Gcms_Post[], key: string, value: string[]) => {
  if (value === []) {
    return [];
  }
  let returnArr: Gcms_Post[] = [];
  arr.forEach((item, index) => {
    if (item[key].some(r => value.includes(r))) {
      arr[index].relationship = getIntersection(item[key], value).length;
      returnArr.push(arr[index]);
    }
  });
  returnArr.sort((a, b) => {
    return b.relationship - a.relationship;
  });
  return returnArr;
};

const PostDetailsPage = ({ location, data }: PostDetailsProps) => {
  const { post, relatedPosts } = data.gcms;
  const realRelatedPosts = filterRelatedPosts(
    relatedPosts,
    'postTags',
    post.postTags,
  );
 
  const reffererPage= location?.state?.refferer ? location.state.refferer : null;

  return (
    <Layout pathname={location.pathname}>
      <SEO
        title={post.title}
        description={post.description}
        slug={post.slug}
        featuredImageUrl={post.featuredImage?.url}
        structuredData={post.structuredData}
      />
      <PostMarkupModule post={post} />
      <PostModule post={post} refferer={reffererPage}/>
      {realRelatedPosts.length > 0 && (
        <PostCarouselModule posts={realRelatedPosts} />
      )}
    </Layout>
  );
};

export const query = graphql`
  query PostDetailsPageQuery($id: ID!) {
    gcms {
      post(where: { id: $id }) {
        title
        metaTitle
        description
        metaDescription
        structuredData
        slug
        postType
        postTopic
        postTags
        sectionNames
        displayDate
        logoImage {
          url
          altText
          vidyardLink
          options
        }
        featuredImage {
          url
          altText
          vidyardLink
          options
        }
        buttonLink
        buttonLabel
        author {
          id
          name
          slug
          jobTitle
          featuredImage {
            url
            altText
            vidyardLink
          }
        }
        body {
          html
        }
        applePodcastsLink
        googlePodcastsLink
        pandoraPodcastsLink
        spotifyPodcastsLink
      }
      relatedPosts: posts(where: { id_not: $id }, orderBy: displayDate_DESC) {
        id
        title
        description
        slug
        postType
        postTopic
        postTags
        sectionNames
        displayDate
        featuredImage {
          url
          altText
          vidyardLink
        }
      }
    }
  }
`;

export default PostDetailsPage;
